import { formatMoney, type Money } from '@loctopus/ticketing-sdk';

export { formatMoney };

export function formatDateRange(startIso?: string, endIso?: string, timeZone?: string): string {
  if (!startIso) return '';
  const start = new Date(startIso);
  const opts: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone,
  };
  const startStr = new Intl.DateTimeFormat('en-AU', opts).format(start);
  if (!endIso) return startStr;
  const end = new Date(endIso);
  const sameDay = start.toDateString() === end.toDateString();
  const endStr = new Intl.DateTimeFormat(
    'en-AU',
    sameDay ? { hour: 'numeric', minute: '2-digit', timeZone } : opts,
  ).format(end);
  return `${startStr} - ${endStr}`;
}

export function isFreeMoney(money: Money | null | undefined): boolean {
  return !money || money.amountMinor === 0;
}
